import { NotificationType, SubscribeToNotificationsDoc } from './api/api';
import {} from '@apollo/client/core';
import { getRealm, stateRealm } from '@infinitro/config';
import { Api, client, getUnvalidatedPlayerSession, loggedIn, toastStore } from '@infinitro/global';
import { refreshWallets } from '@infinitro/global/wallet';
import { get, writable } from 'svelte/store';
import { handleNotificationToast } from './helpers/toasts';
import { app, build, version } from './versioning';
console.log(`${app}@${version} (${build})`);
const initialMessageCountMax = 50;
export const showPersonalNotifications = writable(true);
export const showOnlyUnread = writable(false);
export const notificationsStore = writable([]);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
let initialized = false;
const init = async () => {
    const [playerId] = await getUnvalidatedPlayerSession(realm);
    if (!playerId)
        return;
    const variables = { playerId: playerId, amount: initialMessageCountMax };
    console.log(`subscribing to notifications for ${JSON.stringify(variables)}`);
    client
        .subscribe({
        query: SubscribeToNotificationsDoc,
        variables,
        context: { api: Api.notify }
    })
        .subscribe({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        next: async (data) => {
            const msg = data?.data?.subscribe;
            if (msg?.notificationType === NotificationType.Betby) {
                await refreshWallets();
            }
            if (msg) {
                handleNotificationToast(msg);
                notificationsStore.update((list) => [
                    { ...msg, read: !msg?.payload?.is_live, personal: true },
                    ...list
                ]);
                postMessage(msg);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        error: (error) => {
            console.log(`error on notifications subscription`, error);
        }
    });
    // SubscribeToNotifications({ variables: { playerId: playerId!, amount: initialMessageCountMax } });
    initialized = true;
};
export const markAllAsRead = () => notificationsStore.update((list) => list.map((n) => ({ ...n, read: true })));
let realm = getRealm();
stateRealm.subscribe((value) => {
    if (realm === value)
        return;
    console.log(`visit realm change to ${value}`);
    realm = value;
    initialized = false;
    init();
});
// let _isLoggedIn: boolean | undefined = undefined;
loggedIn.subscribe(async (value) => {
    if (value) {
        // do we need to set a timer to initialize if failed or will Apollo handle that?
        await init();
    }
    else {
        initialized = false;
    }
});
